import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PurchaseRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.purchase_create === true ||
    permissions.purchase_edit === true ||
    permissions.purchase_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default PurchaseRouteMiddleware;
